import React, { forwardRef } from 'react';
import { Button, styled, Typography } from '@mui/material';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { FocusTheme } from '@/components/Focus/configs/theme';

export type CalendarButtonInputProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  date: string;
  time: string;
};

const CalendarButtonInput = forwardRef<HTMLButtonElement, CalendarButtonInputProps>(({ onClick, date, time }, ref) => {
  return (
    <StyledCalendarButtonWrapper>
      <StyledCalendarButton
        ref={ref}
        variant="text"
        startIcon={<PolarisIcon icon="calendar" />}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      >
        <StyledTextWrapper>
          <StyledDateText>{date}</StyledDateText>
          <StyledTimeText>{time}</StyledTimeText>
        </StyledTextWrapper>
      </StyledCalendarButton>
    </StyledCalendarButtonWrapper>
  );
});

const StyledCalendarButtonWrapper = styled('div')`
  min-width: 210px;
`;

const StyledCalendarButton = styled(Button)`
  min-width: 210px;
  padding: 8px;

  .MuiButton-startIcon {
    margin-right: ${({ theme }) => theme.spacing(3)};
    color: ${({ theme }) => (theme as FocusTheme).palette.neutral[20]};
  }
`;

const StyledTextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledDateText = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.common.white};
`;

const StyledTimeText = styled(Typography)`
  font-size: 14px;
  line-height: 1.2;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[20]};
`;

CalendarButtonInput.displayName = 'CalendarButtonInput';

export default CalendarButtonInput;
